module.exports = __webpack_public_path__ + "static/media/filled_bar_shotStrip.74e6c6a1.svg";